import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-86a9c6ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "art_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Predict age based on a name", -1))
const _hoisted_4 = { class: "user-info" }
const _hoisted_5 = {
  key: 0,
  style: {"color":"red"}
}

import { reactive } from "@vue/runtime-core";
import axios from "axios";
import SearchInfo from "@/components/SearchInfo.vue";

interface info {
  name: string;
  age: number;
  count: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  setup(__props) {

const data: info = reactive({
  name: "",
  age: 0,
  count: "",
});

const get = (name: string) => {
  axios.get(`https://api.agify.io/?name=${name}`).then((res) => {
    data.name = res.data.name;
    data.age = res.data.age;
    data.count = res.data.count;
    console.log(res.data);
  });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", null, [
          _hoisted_3,
          _createElementVNode("li", null, [
            _createVNode(SearchInfo, { onSubmit: get }),
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("span", null, "Name : " + _toDisplayString(data.name), 513), [
                [_vShow, data.name]
              ]),
              (data.age == null || data.age == undefined)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "You Are Giving Incorrect Information"))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("span", null, "Age: " + _toDisplayString(data.age), 513), [
                [_vShow, data.age > 0]
              ]),
              _withDirectives(_createElementVNode("span", null, "Posta Code: " + _toDisplayString(data.count), 513), [
                [_vShow, data.count]
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})